// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-App-Components-LabelWithIcon-style__labelWithIconWrapper--eO7mU{display:flex;padding:5px 2.5px}.src-App-Components-LabelWithIcon-style__labelWithIconWrapper--eO7mU .src-App-Components-LabelWithIcon-style__faIcon--P4LHb{color:gray;align-self:center}.src-App-Components-LabelWithIcon-style__labelWithIconWrapper--eO7mU p{align-self:center;margin:0;padding-left:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelWithIconWrapper": "src-App-Components-LabelWithIcon-style__labelWithIconWrapper--eO7mU",
	"faIcon": "src-App-Components-LabelWithIcon-style__faIcon--P4LHb"
};
export default ___CSS_LOADER_EXPORT___;
